import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
export function createApiKeysApi(baseUrl) {
    const apiKeysApi = createApi({
        reducerPath: `apiKeysApi_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        tagTypes: [
            "ApiKeys"
        ],
        endpoints: (build)=>({
                getApiKeys: build.query({
                    query: ()=>({
                            url: "api/admin/api-keys",
                            method: "GET"
                        }),
                    providesTags: [
                        "ApiKeys"
                    ],
                    transformResponse: (response)=>response.api_keys
                }),
                createApiKey: build.mutation({
                    query: (body)=>({
                            url: "api/admin/api-keys",
                            method: "POST",
                            body
                        }),
                    invalidatesTags: [
                        "ApiKeys"
                    ]
                }),
                revokeApiKey: build.mutation({
                    query: ({ id })=>({
                            url: `api/admin/api-keys/${id}`,
                            method: "DELETE"
                        }),
                    invalidatesTags: [
                        "ApiKeys"
                    ]
                })
            })
    });
    return apiKeysApi;
}
